<mat-card class="topventas p-5">
    <mat-card-header class="d-grid">
        <mat-card-title>Top productos
            <div class="filtro">
                <form [formGroup]="form">
                    <select class="form-select" aria-label="Default select example" formControlName="mes">
                        <option [value]="item.id" *ngFor="let item of listaMeses">{{item.descripcion}}</option>
                    </select>
                </form>
                <p>Mes</p>
            </div>
        </mat-card-title>
        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
        <div class="porcentan">
            <span class="badge rounded-pill bg-badge" [ngStyle]="{'color': ColorPorcentajeMesAnterior()}">{{porcentajeMesAnterior}}%
                <mat-icon aria-hidden="false" aria-label="Example home icon" *ngIf="porcentajeMesAnterior <= 0">arrow_downward</mat-icon>
                <mat-icon aria-hidden="false" aria-label="Example home icon" *ngIf="porcentajeMesAnterior > 0">arrow_upward</mat-icon>
            </span>
            <p>Frente al periodo anterior</p>
        </div>
    </mat-card-header>
    <mat-card-content>
        <ul>
            <li *ngFor="let item of this.productosService.ListaTopProductosResumen">
                <div class="product">
                    <p><strong>{{item.producto}}</strong>{{item.aliado}}</p>
                </div>
                <div class="venta">
                    <div class="circle mr-3">
                        <div class="percent1" [ngStyle]="{'stroke-dashoffset': ObtenerPorcentajeResumen(item)}">
                            <svg>
                              <circle cx="60" cy="20" r="20"></circle>
                              <circle cx="60" cy="20" r="20"></circle>
                            </svg>
                        </div>
                    </div>
                    <div class="percent">
                        <p>Ventas <br>{{item.cantidadPorcentaje}}%</p>
                    </div>
                </div>
            </li>
        </ul>
    </mat-card-content>
</mat-card>